// extracted by mini-css-extract-plugin
module.exports = {"caption":"a10a3f92e9--caption--Ec40f","price":"a10a3f92e9--price--w7ha0","price_tooltip":"a10a3f92e9--price_tooltip--QAjLo","caption_tooltip":"a10a3f92e9--caption_tooltip--RkYrV"};